module.exports = __webpack_public_path__ + "p5_img5.jpg?c19e9127df908a799ea6c39af81fddde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img5.jpg
// module id = 121
// module chunks = 0